import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-06/task-01";

const task: Slide = {
  titleHtml:
    "You are in a highly reverberant room with all surfaces consisting of concrete. If you<br>want to listen to a clear, crisp sound produced by a trumpet player, with very little<br>reverberation, where will you sit?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
